import { FC, useMemo } from "react";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

const WidgetTemplate10: FC<IWidgetTemplate> = ({ company, theme }) => {
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 10 as const }),
    [companyId],
  );

  const companyUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=review-collector`,
    [companyId],
  );

  return (
    <div className="overflow-hidden d-flex justify-content-center">
      <a
        className="text-decoration-none"
        style={{ color: theme === "dark" ? "white" : "unset" }}
        href={companyUrl}
        target="_blank"
        rel="noreferrer noopener"
        onClick={() => ReachClick(payload)}
      >
        <div className="border border-primary d-flex mt-4">
          <div className="fs-16 d-flex align-items-center p-2 fw-bold">
            Reviews us on
          </div>
          <div className="d-flex align-items-center txt p-2">
            <img src={LOGO_MARK} alt="TrustFinance" width={24} height={24} />
            <span className="fs-16">TrustFinance</span>
          </div>
        </div>
      </a>
    </div>
  );
};

export default WidgetTemplate10;
